export const INDEXES_TYPES = {
  UNIQUE: 'UNIQUE',
  INDEX: 'INDEX',
};
